module.exports = __webpack_public_path__ + "ts-logo-color.a789f0fb111dc0c4eaa65dec9b845992.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/ts-logo-color.svg
// module id = 1629
// module chunks = 39